import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { API } from "../../utils/axios";

export default function BusinessEmailVerificationReminder() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  const resendVerificationLink = async () => {
    if (!email) {
      toast.error("Server Error. Please try again");
    }
    try {
      const { data } = await API.post(
        "/business/resend-verification-email",
        { email }
      );
      toast.success(data.message);
    } catch (err) {
      console.log(err);
    }
  };

  //   useEffect(() => {
  //     if (typeof window !== "undefined" && typeof window.gtag === "function") {
  //       window.gtag("event", "conversion", {
  //         send_to: "AW-17685944295/2yFlCOzW370bE0evqPFB",
  //       });
  //     }
  //   }, []);

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="w-full max-w-2xl bg-white p-6 sm:p-8 transform transition-all duration-300 scale-100 hover:scale-[1.01] flex flex-col items-center text-center space-y-4">
        <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
          This is a reminder to verify your Email to proceed with successful
          business account creation
        </p>
        {/* <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            Your form is submitted successfully
          </p> */}
        <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
          A verification email will be send to your inbox.
          <br />
          Please check your email and verify your account to continue.
        </p>
        <div className="mt-10">
          <button
            onClick={resendVerificationLink}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow transition-all"
          >
            Resend Verification Email
          </button>
        </div>
        <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
          In case, if you didn't see email in your inbox, please check span
          folder
        </p>
      </div>
    </div>
  );
}
